export function nvl(value: string | null | undefined) {
  return value == null ? "-" : value;
}
